export enum TaskTypes {
  GeneralTask = 'GENERAL_TASK',
  PeopleTask = 'PEOPLE_TASK',
}
